import { useSeoMeta, useHead, useRoute, useRuntimeConfig } from "#app";
import { isString, stripHtml } from "@spoferan/spoferan-ts-core";
function removeUndefinedValues(obj) {
  return Object.entries(obj).filter(([key, value]) => value !== void 0).reduce((obj2, [key, value]) => {
    obj2[key] = value;
    return obj2;
  }, {});
}
export function useMeta(props) {
  const route = useRoute();
  const config = useRuntimeConfig();
  const title = props.title ? stripHtml(props.title) : void 0;
  const description = props.description ? stripHtml(props.description) : void 0;
  const metaData = {
    title,
    titleTemplate: props.titleTemplate,
    ogTitle: title,
    description,
    ogDescription: description,
    ogImageUrl: props.image,
    ogImageSecureUrl: props.image,
    ogType: props.type,
    robots: props.noIndex ? "noindex" : void 0
  };
  useSeoMeta(removeUndefinedValues(metaData));
  const scripts = [];
  if (props.scripts?.length) {
    props.scripts.forEach((script) => {
      if (isString(script)) {
        scripts.push({ src: script, type: "text/javascript", async: true });
      } else {
        scripts.push(script);
      }
    });
  }
  let canonicalUrl = props.canonical;
  if (canonicalUrl === true || canonicalUrl === void 0) {
    canonicalUrl = `${config.public.appUrl}${route.path}`;
    if (props.canonicalQueries) {
      const query = route.query;
      const canonicalQueryString = props.canonicalQueries.map((key) => query[key] !== void 0 ? `${key}=${query[key]}` : void 0).filter(Boolean).join("&");
      if (canonicalQueryString.length) {
        canonicalUrl += "?" + canonicalQueryString;
      }
    }
  }
  if (scripts.length || canonicalUrl || props.meta?.length) {
    useHead({
      script: scripts.length ? scripts : void 0,
      meta: props.meta || void 0,
      link: canonicalUrl ? [{ rel: "canonical", href: canonicalUrl }] : void 0
    });
  }
}
